module.exports = __webpack_public_path__ + "static/media/sistemaPegar3.a7972b88.jpg";